import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import { QuickSummaryButtonPlaceholder } from '../src/QuickSummaryButtonPlaceholder.tsx';
import type { QuickSummaryPopupProps } from '../src/QuickSummaryPopup.tsx';

export const QuickSummaryPopup: LoadableType<QuickSummaryPopupProps> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-QuickSummaryPopup" */ '../src/QuickSummaryPopup.tsx'
			)
		).QuickSummaryPopup,
	loading: ({ buttonStyles }) => <QuickSummaryButtonPlaceholder buttonStyles={buttonStyles} />,
});
